class DeleteBeneficiary {
	constructor(
		public readonly facilityId: number,
		public readonly beneficiaryId: number,
	) {
		Object.freeze(this);
	}
}

export default DeleteBeneficiary;
